export const FEATURES = [
  {
    title: 'Gratis & product seeding',
    href: '/sellwithflip',
    id: 'sales-dashboard',
  },
  {
    title: 'Product video reviews & engagement ',
    image: 'magic/products/magic2.jpg',
    href: '/sellwithflip',
    id: 'inventory-management',
  },
  {
    title: 'Access to organic user generated content (UGC)',
    image: 'magic/products/magic3.jpg',
    href: '/sellwithflip',
    id: 'analytics-tracking',
  },
  {
    title: 'Boost content to drive awareness & sales ',
    image: 'magic/products/magic4.jpg',
    href: '/sellwithflip',
    id: 'gratis-management',
  },
  {
    title: 'Performance analytics & reporting',
    image: 'magic/products/magic5.jpg',
    href: '/sellwithflip',
    id: 'orders',
  },
  {
    title: 'Seamlessly integrates with your existing e-commerce platform',
    image: 'magic/products/magic6.jpg',
    href: '/sellwithflip',
    id: 'performance',
  },
]
